<template>
  <div class="flex items-center h-full">
    <!-- Enabled: "bg-indigo-600", Not Enabled: "bg-gray-200" -->
    <button
      type="button"
      :class="[enabled ? 'bg-green-600' : 'bg-gray-200', disabled ? 'disabled' : 'outline']"
      @click="clicked"
      aria-labelledby="toggle-label"
    >
      <!-- Enabled: "translate-x-5", Not Enabled: "translate-x-0" -->
      <span aria-hidden="true" :class="enabled ? 'enabled' : ''"></span>
    </button>
    <span class="ml-3" id="toggle-label">
      <span class="label">{{ label }}</span>
    </span>
  </div>
</template>

<script>
export default {
  name: 'Toggle',

  data() {
    return {
      enabled: true,
    };
  },
  props: {
    label: {
      type: String,
    },
    default: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  created() {
    this.enabled = this.default;
  },

  methods: {
    get() {
      return this.enabled;
    },
    clicked() {
      if (!this.disabled) {
        this.enabled = !this.enabled;
      }
    },
  },
};
</script>

<style scoped>
button {
  @apply relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none;
}

.outline {
  @apply focus:ring-2 focus:ring-offset-2 focus:ring-green-500;
}

button span {
  @apply -translate-x-2 pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200;
  min-width: 1.25rem;
}

.disabled {
  pointer-events: none;
}

.enabled {
  @apply translate-x-2;
}

.label {
  @apply text-sm font-medium text-gray-900;
}
</style>